export default __webpack_public_path__ + "images/highlight_headers.9813287.svg";